import { Box, Skeleton } from "@mui/material";

export const LoadingState = () => (
    <Box sx={{ pt: 1, pb: { xs: 2, sm: 4 } }}>
        <Skeleton variant="rectangular" sx={{ height: 24, mt: 4 }} />
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "repeat(2, 1fr)", sm: "repeat(4, 1fr)" } }}>
            {[1, 2, 3, 4].map(key => (
                <Skeleton key={key} variant="rectangular" sx={{ width: 80, height: "12px", mt: { xs: 0.5, sm: 2 }, mx: "auto" }} />
            ))}
        </Box>
    </Box>
);
